/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './message.scss';
import MessageLink from './MessageLink';
import MessageQuickEvent from './MessageQuickEvent';

type messageQrDynamicProp = {
    message: any,
    quickReplyHandler: any,
    sessionId?: any,
    userId?: any,
}

const MessageQrDynamic = ({message, quickReplyHandler, sessionId, userId}: messageQrDynamicProp) => {
    let callbackType = "";
    const callback = message.data.callback;

    if (callback !== undefined && callback !== null) {
        if (callback.hasOwnProperty('url')) {
            callbackType = "link";
        } else if (callback.hasOwnProperty('event')) {
            callbackType = "event";
        }
    }

    return (
        <div>
            {callbackType === 'link' && <MessageLink text={message.text} link={callback.url} sessionId={sessionId} userId={userId} intentGroupId={ message.intentGroupId } intentGroupName={ message.intentGroupName } type={ message.type } />}
            {callbackType === 'event' && <MessageQuickEvent text={message.text} quickReplyHandler={quickReplyHandler} eventName={callback.event} showTextResponse={false} />}
        </div>       
    )
}

export default MessageQrDynamic



